import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const FullscreenLoader = () => (
  <div className="grid min-h-screen place-items-center bg-brand-mist" data-testid="admin-loading">
    <Loader2 className="h-8 w-8 animate-spin text-brand-blue" />
  </div>
);

export const RequireAuth = () => {
  const { user } = useAuth();
  if (user === null) return <FullscreenLoader />;
  if (!user) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
};
